import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { CompanyInteractionMostActiveUserGraphData, CompanyInteractionMostActiveUserGraphDataQuery, TopIcContributers, TopIcContributersDataQuery } from '@core/models/analytics-dashboard-models';
import { Company } from '@core/models/company';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiResponse, BaseApiService } from 'src/app/api/base';
import { BreakInMember, ElevationMember, ElevationStatusCounts, NoiticleBreakin } from 'src/app/components/elevation-report/elevation-report.component';

export interface RecentBreakInsResponse {
  results: BreakInMember[];
}

export interface ElevationStatsResponse {
  results: ElevationMember[];
}

export interface FirmwideElevationOutcomesResponse {
  totalElevatedCompanies: number;
  segmentCounts: ElevationStatusCounts;
}

@Injectable({
  providedIn: 'root'
})
export class ElevationReportService extends BaseApiService<Company> {

  constructor(authService: AuthService, router: Router, messageService: MessageService) {
    super('/report', authService, router, messageService);
  }   

  public getFirmwideElevationOutcomes(days: number = 30): Observable<ApiResponse<FirmwideElevationOutcomesResponse >> {
    return this.get(`/reports/firmwide-elevation-outcomes`);
  }

  public getBreakinCredits(days: number): Observable<ApiResponse<RecentBreakInsResponse>> {
    const params = new URLSearchParams();
    if (days !== undefined) params.append('days', days.toString());
    return this.get(`/break-in-stats?${params.toString()}`);
  }

  public getElevationStats(days: number): Observable<ApiResponse<ElevationMember[]>> {
    const params = new URLSearchParams();
    if (days !== undefined) params.append('days', days.toString());
    return this.get(`/user-elevation-stats?${params.toString()}`);
  }
}